import { render } from "./famousCourseHumanityLookVideo.vue?vue&type=template&id=382b6602&scoped=true"
import script from "./famousCourseHumanityLookVideo.vue?vue&type=script&lang=js"
export * from "./famousCourseHumanityLookVideo.vue?vue&type=script&lang=js"

import "./famousCourseHumanityLookVideo.vue?vue&type=style&index=0&id=382b6602&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\LyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382b6602"]])

export default __exports__